import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import FormattedCurrency from '../../../../../components/formatted-currency';
import { getNonWalletAccessDisplayPrice, useShowNonWalletUpgradeSpeedbump } from '../../../../../hooks/non-wallet-access-hooks';
import Global from '../../../../../store/global-selectors';
import { useGetSimplifiedPlanExperimentName } from '../../../payment-and-subscription/components/plan-name-helper';
import messages from '../../messages';
import style from '../carriers-additional.module.less';

export const CarrierFeeBanner = () => {
  const { currentBillingPlan, planToNonWalletAccessPlanMap } = useSelector(Global.selectSellerSubscriptionData);
  const planName = useGetSimplifiedPlanExperimentName(currentBillingPlan);
  const nonWalletAccessPlan = planToNonWalletAccessPlanMap?.[currentBillingPlan?.billingPlanId];
  const yourCarriersPrice = getNonWalletAccessDisplayPrice(currentBillingPlan, nonWalletAccessPlan);
  const shouldShowNonWalletAccessSpeedbump = useShowNonWalletUpgradeSpeedbump();
  const showBanner = shouldShowNonWalletAccessSpeedbump && yourCarriersPrice > 0;

  if (showBanner) {
    return (
      <BannerMessageV2
        className={style.disclaimer}
        content={
          <FormattedMessage
            {...messages.yourCarrierFeeDisclaimer}
            values={{
              feeAmount: <FormattedCurrency currencyCode={currentBillingPlan?.pricePerPeriod?.code} value={yourCarriersPrice} />,
              planName,
            }}
          />
        }
        status={BannerStatus.Info}
      />
    );
  }
};
